"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const defaults_js_1 = __importDefault(require("axios/lib/defaults.js"));
const mergeConfig_js_1 = __importDefault(require("axios/lib/core/mergeConfig.js"));
const merged = mergeConfig_js_1.default(defaults_js_1.default, {
    timeout: 5000,
    method: 'get',
    responseType: 'json',
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { transformRequest, transformResponse } = merged, omited = __rest(merged, ["transformRequest", "transformResponse"]);
exports.default = omited;
//# sourceMappingURL=defaultConfig.js.map